import { render, staticRenderFns } from "./Movement_Entry_OrderGTINDetail.vue?vue&type=template&id=32fac6c6&scoped=true&"
import script from "./Movement_Entry_OrderGTINDetail.vue?vue&type=script&lang=js&"
export * from "./Movement_Entry_OrderGTINDetail.vue?vue&type=script&lang=js&"
import style0 from "./Movement_Entry_OrderGTINDetail.vue?vue&type=style&index=0&id=32fac6c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fac6c6",
  null
  
)

export default component.exports